import {AfterViewInit, Directive, OnDestroy, TemplateRef} from '@angular/core';
import {DefaultComponent} from './default.component';

@Directive({
  selector: '[imsAffixHeader]'
})
export class AffixHeaderDirective implements AfterViewInit, OnDestroy {

  constructor(private tpl: TemplateRef<any>, private parent: DefaultComponent) {
  }

  ngAfterViewInit(): void {
    this.parent.attachHeader(this.tpl);
  }

  ngOnDestroy(): void {
    this.parent.detachHeader();
  }

}
